export const resolveFillerFullName = (formData) => {
  const fillerFirstName =
    formData?.formSubmissionDetails?.fillersFirstName?.trim() || "";
  const fillerLastName =
    formData?.formSubmissionDetails?.fillersLastName?.trim() || "";

  return [fillerFirstName, fillerLastName].filter(Boolean).join(" ");
};

export const replaceDescriptionPlaceholders = (text, formData) => {
  if (typeof text !== "string") {
    return text;
  }

  const fillerFullName = resolveFillerFullName(formData);

  return text.replace(/\{fillerFullName\}/g, fillerFullName);
};

export const renderMarkdownBold = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, index) => {
    const isBold = part.startsWith("**") && part.endsWith("**");

    return isBold ? <strong key={index}>{part.slice(2, -2)}</strong> : part;
  });
